import { Drawer } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import HeaderTitle from '../../common/HeaderTitle';
import { getSpecificationDetailBpo, getSpecificationDetailTco } from '../actions/Costing';
import { QuotationId } from '../../rfq/ViewRfq';
import LoaderCustom from '../../common/LoaderCustom';
import { TextFieldHookForm } from '../../layout/HookFormInputs';
import { Controller, useForm } from 'react-hook-form';
import NoContentFound from '../../common/NoContentFound';
import { EMPTY_DATA, TOOLING } from '../../../config/constants';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import SOPListing from './SOPListing';
import _ from 'lodash';
import DayTime from '../../common/DayTimeWrapper';
import { getConfigurationKey, isPlantMultiSelectEnabled, searchNocontentFilter } from '../../../helper';
 
const PartSpecificationDrawer = (props) => {
    const gridOptions = {};
    const { register, control, formState: { errors } } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    });
    const [isLoader, setIsLoader] = useState(false);
    const quotationId = useSelector((state) => state.rfq.quotationIDForRFQ ?? '');
    const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [noData, setNoData] = useState(false);
    const dispatch = useDispatch();
    const { quotationDetailsList } = useSelector((state) => state?.rfq);
    const { partSpecificationRFQData } = useSelector((state) => state?.costing);
    const [gridsApi, setGridsApi] = useState({
        firstGrid: { api: null, columnApi: null },
        secondGrid: { api: null, columnApi: null },
    });

    const toggleDrawer = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        props.closeDrawer('');
    };
    const { baseCostingId, bopId, bopQuotationId, plantId } = props
    useEffect(() => {
        setIsLoader(true);
        if (baseCostingId?.length > 0) {
            dispatch(getSpecificationDetailTco(quotationId, baseCostingId, plantId, (res) => {

                let Data = res?.data?.Data
                if (Data?.SpecsHead && Data?.SpecsColumn) {

                    setColumnDefs(generateColumnDefs(Data?.SpecsHead));
                    setRowData(Data?.SpecsColumn); // Directly use SpecsColumn as row data
                }
                setIsLoader(false);
            }));
        }
        else if (bopId?.length > 0) {
            setIsLoader(true);
            dispatch(getSpecificationDetailBpo(bopQuotationId, bopId, (res) => {
                let Data = res?.data?.Data
                if (Data?.SpecsHead && Data?.SpecsColumn) {
                    setColumnDefs(generateColumnDefs(Data?.SpecsHead));
                    setRowData(Data?.SpecsColumn); // Directly use SpecsColumn as row data
                }
                setIsLoader(false);
            }));
        }

        else {
            setIsLoader(false);
        }

    }, [quotationId, baseCostingId, dispatch]);

    const generateColumnDefs = (specsHead) => {
        return specsHead.map((head, index) => ({
            headerName: head,
            field: head, // Use the head value directly as the field name
            sortable: true,
            filter: true,
            cellRenderer: index >= 2 ? 'vendorDataRenderer' : undefined,

        }));
    };
    const VendorDataRenderer = (props) => {
        const specValueField = 'Part Specs Value'; // The field name for the specification value
        const vendorValue = props.value;
        const specValue = props.data[specValueField];
        const isChanged = vendorValue !== specValue && vendorValue !== null && vendorValue !== undefined && vendorValue !== '';

        return (
            <span style={{ color: isChanged ? 'red' : 'inherit' }}>
                {vendorValue !== null && vendorValue !== undefined ? vendorValue : '-'}
            </span>
        );
    };

    const GroupedCellRenderer = (props) => {
        const { value, data, api } = props;

        if (!api) return null;

        // Get all row data
        const allRows = [];
        api.forEachNode(node => allRows.push(node.data));

        // Group by PlantCode to find rows with same plant
        const groupField = 'PlantCode';
        const sameGroupRows = allRows.filter(row => row[groupField] === data[groupField]);

        // Find the index of current row in the same group
        const currentIndex = sameGroupRows.findIndex(row =>
            row.YearName === data.YearName &&
            row[groupField] === data[groupField]
        );

        // Calculate middle index
        const middleIndex = Math.floor(sameGroupRows.length / 2);

        // Only show value for the middle row
        if (currentIndex === middleIndex) {
            return (
                <div style={{
                    fontWeight: '500',
                    color: '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%'
                }}>
                    {value || '-'}
                </div>
            );
        }

        return null;
    };

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        floatingFilter: true,
    };
 
    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            rowData.length !== 0 && setNoData(searchNocontentFilter(value, noData))
        }, 500);
    }
 
    const onGridReady = (params, gridIdentifier) => {
        setGridsApi(prev => ({
            ...prev,
            [gridIdentifier]: { api: params.api, columnApi: params.columnApi },
        }));

        params.api.paginationGoToPage(0);
        params.api.sizeColumnsToFit();
    };

    const getRowStyle = (params) => {
        if (!params.api || !params.data) return {};

        // Get all rows
        const allRows = [];
        params.api.forEachNode(node => allRows.push(node.data));

        // Find current row index
        const currentRowIndex = allRows.findIndex(row =>
            row.YearName === params.data.YearName &&
            row.PlantCode === params.data.PlantCode
        );

        // Check if this is the last row of a plant group
        const isLastRowOfGroup = currentRowIndex < allRows.length - 1 &&
            allRows[currentRowIndex].PlantCode !== allRows[currentRowIndex + 1]?.PlantCode;

        if (isLastRowOfGroup) {
            return {
                borderBottom: '2px solid #d0d0d0',
            };
        }

        return {};
    };

    const frameworkComponents = {
        customLoadingOverlay: LoaderCustom,
        customNoRowsOverlay: NoContentFound,
        vendorDataRenderer: VendorDataRenderer,
        groupedCellRenderer: GroupedCellRenderer,
    };

    return (

        <Drawer className="top-drawer" anchor={"right"} open={props?.isOpen} onClose={toggleDrawer}>
            <Container>

                <div className="drawer-wrapper layout-min-width-720px">
                    <Row className="drawer-heading">
                        <Col>
                            <div className="header-wrapper left">
                                <h3>{`${getConfigurationKey()?.IsShowTCO ? props.type === 'BOP' ? 'BOP' : 'TCO' : ''} Specification Detail`}</h3>
                            </div>
                            <div onClick={toggleDrawer} className="close-button right"></div>
                        </Col>
                    </Row>
                    {isLoader ?
                        <LoaderCustom customClass="loader-center" /> :
                        <>
                            <Col md="12">
                                {getConfigurationKey()?.IsShowTCO && <>

                                    <HeaderTitle title="Specifications" customClass="mt-3" />
                                    {rowData?.length > 0 && (
                                        <Row className="mt-1 part-detail-wrapper">
                                            {props.type !== 'BOP' && props.partType !== 'Tooling' && (<Col md="3">
                                                <TextFieldHookForm
                                                    label="Havells Design Part"
                                                    name="HavellsDesignPart"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    disabled={true}
                                                    defaultValue={partSpecificationRFQData?.HavellsDesignPart || ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Specification}
                                                />
                                            </Col>)}
                                            {props.type !== 'BOP' && props.partType !== 'Tooling' && (<Col md="3">
                                                <TextFieldHookForm
                                                    label="Target Price"
                                                    name="TargetPrice"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    rules={{ required: false }}
                                                    mandatory={false}
                                                    defaultValue={partSpecificationRFQData?.TargetPrice || ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Description}
                                                    disabled={true}
                                                    placeholder="-"
                                                />
                                            </Col>)}
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    label="UOM"
                                                    name="UOMSymbol"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    rules={{ required: false }}
                                                    mandatory={false}
                                                    defaultValue={partSpecificationRFQData?.UOMSymbol || ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Description}
                                                    disabled={true}
                                                    placeholder="-"
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    label="Date"
                                                    name="TimeLine"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    rules={{ required: false }}
                                                    mandatory={false}
                                                    defaultValue={partSpecificationRFQData?.TimeLine ? DayTime(partSpecificationRFQData?.TimeLine).format('DD/MM/YYYY') : ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Description}
                                                    disabled={true}
                                                    placeholder="-"
                                                />
                                            </Col>
                                            {props.type !== 'BOP' && (<Col md="3">
                                                <TextFieldHookForm
                                                    label={props?.partType === 'Tooling' ? "Tool Number" : "Part Number"}
                                                    name="PartNumber"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    rules={{ required: false }}
                                                    mandatory={false}
                                                    defaultValue={partSpecificationRFQData?.SOPQuantityDetails?.PartNumber || ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Description}
                                                    disabled={true}
                                                    placeholder="-"
                                                />
                                            </Col>)}
                                            {props?.partType === TOOLING && (<Col md="3">
                                                <TextFieldHookForm
                                                    label={"Tool Life"}
                                                    name="toolLife"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    rules={{ required: false }}
                                                    mandatory={false}
                                                    defaultValue={partSpecificationRFQData?.AdditionalDetailsForPart
                                                        ?.ToolLife
                                                        || ""}
                                                    className=""
                                                    customClassName="withBorder"
                                                    errors={errors.Description}
                                                    disabled={true}
                                                    placeholder="-"
                                                />
                                            </Col>)}
                                        </Row>
                                    )}
                                </>}
                                <div className="ag-grid-react border">
                                    <div className={`ag-grid-wrapper ${rowData?.length > 0 ? "height-auto" : "height-auto overlay-contain"}`} style={{minHeight: rowData?.length > 0 ? 'auto' : '200px'}}>
                                        <div className="ag-theme-material">

                                            <AgGridReact
                                                defaultColDef={defaultColDef}
                                                floatingFilter={true}
                                                domLayout="autoHeight"
                                                gridOptions={gridOptions}
                                                columnDefs={columnDefs}
                                                rowData={rowData}
                                                onGridReady={(e) => onGridReady(e, "firstGrid")}
                                                loadingOverlayComponent="customLoadingOverlay"
                                                noRowsOverlayComponent="customNoRowsOverlay"
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                    imagClass: 'imagClass pt-3',
                                                    customClassName: "no-content-found"
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressRowClickSelection={true}
                                                rowSelection="multiple"
                                                onFilterModified={onFloatingFilterChanged}
                                            />
                                            {noData && <NoContentFound title={EMPTY_DATA} />}
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <Col md="12" className="mt-3">
                                <div className="ag-grid-react">
                                    <div className={`ag-grid-wrapper height-auto ${partSpecificationRFQData?.SOPQuantityDetails?.length <= 0 ? "overlay-contain" : ""}`}>
                                        <div className="ag-theme-material">
                                    {partSpecificationRFQData?.SOPQuantityDetails && partSpecificationRFQData?.SOPQuantityDetails?.length > 0 ? (
                                        <AgGridReact
                                            defaultColDef={{
                                                ...defaultColDef,
                                                sortable: true,
                                                floatingFilter: false,
                                            }}
                                            domLayout="autoHeight"
                                            frameworkComponents={frameworkComponents}
                                            suppressRowClickSelection={true}
                                            rowSelection="multiple"
                                            rowData={partSpecificationRFQData?.SOPQuantityDetails}
                                            onGridReady={(e) => onGridReady(e, "secondGrid")}
                                            getRowStyle={getRowStyle}
                                            noRowsOverlayComponentParams={{
                                                title: EMPTY_DATA,
                                                imagClass: 'imagClass pt-3',
                                                customClassName: "no-content-found"
                                            }}
                                        >
                                            {isPlantMultiSelectEnabled() && <AgGridColumn
                                                width={"230px"}
                                                field="PlantCode"
                                                headerName="Plant Name"
                                                cellRenderer="groupedCellRenderer"
                                                cellStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            ></AgGridColumn>}
                                            <AgGridColumn width={"230px"} field="YearName" headerName="Production Year"></AgGridColumn>
                                            <AgGridColumn width={"230px"} field="Quantity" headerName="Annual Forecast Quantity" colId="Quantity"></AgGridColumn>
                                            {isPlantMultiSelectEnabled() && <AgGridColumn
                                                width={"230px"}
                                                field="HitRatePerDay"
                                                headerName="Hit Rate Per Day"
                                                colId="HitRatePerDay"
                                                cellRenderer="groupedCellRenderer"
                                                cellStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            ></AgGridColumn>}
                                            {/* Additional columns can be added here */}
                                        </AgGridReact>
                                    ) : null}
                                </div>
                            </div>
                            </div>
                            </Col>
                        </>
                    }

                </div>
            </Container>
        </Drawer>

    );
};

export default PartSpecificationDrawer;
